import { Button } from "components/Button";
import { Header } from "components/Header";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useHistory } from "react-router-dom";
import { useFaqsTable, EventFaq } from "./useFaqsTable";
import { Container } from "./styles";

const tableHead = [
  "Pergunta", 
  "Resposta", 
  "Ordem",
  "Status",
  "Ações"
];

export const FaqsTable: React.FC = () => {
  const { push } = useHistory();

  const handleCreateFaq = () => {
    push(`/events/${eventId}/faq/create`);
  };

  const handleEditFaq = (faq: EventFaq) => {
    push(`/events/${eventId}/faq/${faq.eventFaqId}/edit`);
  };

  const {
    loading,
    error,
    properties,
    faqRows,
    faqs,
    eventId,
  } = useFaqsTable(handleEditFaq);

  return (
    <Container>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', marginBottom: "1rem" }}>
          <h2>FAQs do Evento</h2>
          <Button 
            label="Criar FAQ" 
            typeBtn="blue"
            onClick={handleCreateFaq}
          />
        </div>
      </div>
      
      {loading ? (
        <Loading />
      ) : error ? (
        <PlaceHolderNotExists title="Erro ao se comunicar com o servidor" />
      ) : (
        <>
          <TableModifiedCards properties={properties} />
          <TableModifiedTable
            headerColumns={tableHead}
            rows={faqRows}
            onRowClick={(_, rowIndex) => {
              if (faqs && faqs[rowIndex]) {
                handleEditFaq(faqs[rowIndex]);
              }
            }}
          />
        </>
      )}
    </Container>
  );
}; 